import ToastStore from "./base";

const toastStore = new ToastStore()
export default toastStore;
